import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MailTemplateItem } from '../../../external/MailTemplateApi';
import { actions } from '../../modules/Actions';

export interface MailTemplateState {
  hit: number;
  mailTemplate: MailTemplateItem[];
}

export const initialState: MailTemplateState = {
  hit: 0,
  mailTemplate: []
};

export const MailTemplateReducer = reducerWithInitialState(initialState)
  .case(
    actions.fetchMailTemplate, (state: MailTemplateState, payload: MailTemplateState) => {
      return payload;
    }
  );

